<app-user-dashboard [fullScreen]="true">
  <div class="bg-container" id="virtual-comex">
    <div class="container">

      <div class="column-img fade-in-right-js only-desktop">
        <figure class="figure-img">
          <img src="../../../../assets/img/to_do_fruzty/procurement_virtual.png" style="width: 80%" alt="flag"/>
        </figure>
      </div>

      <div class="column-info fade-in-up-js">
        <h1 class="title fade-in fade-in-delay">{{'VirtualProcurement.Title' | translate}}</h1>
        <div class="container-row">
          <div class="container-subtitle fade-in fade-in-delay-2">
            <i class="figure-circle"></i>
            <h3 class="subtitle-main">
              {{'VirtualProcurement.Subtitle1' | translate}}
            </h3>
          </div>
          <p class="text-info fade-in fade-in-delay-3">
            {{'VirtualProcurement.Text1Part1' | translate}} <strong style="font-weight:600">{{'VirtualProcurement.Text1Part2' | translate}} </strong>{{'VirtualProcurement.Text1Part3' | translate}}.
          </p>
        </div>
        <div class="container-row">
          <div class="container-subtitle fade-in fade-in-delay-4">
            <i class="figure-circle"></i>
            <h3 class="subtitle-main">
              {{'VirtualProcurement.Subtitle2' | translate}}
            </h3>
          </div>
          <p class="text-info fade-in fade-in-delay-5">
            {{'VirtualProcurement.Text2Part1' | translate}} <strong style="font-weight:600">{{'VirtualProcurement.Text2Part2' | translate}} </strong>{{'VirtualProcurement.Text2Part3' | translate}}.
          </p>
        </div>
        <div class="container-row">
          <div class="container-subtitle fade-in fade-in-delay-6">
            <i class="figure-circle"></i>
            <h3 class="subtitle-main">
              {{'VirtualProcurement.Subtitle3' | translate}}
            </h3>
          </div>
          <p class="text-info fade-in fade-in-delay-7">
            {{'VirtualProcurement.Text3Part1' | translate}} <strong style="font-weight:600">{{'VirtualProcurement.Text3Part2' | translate}} </strong>{{'VirtualProcurement.Text3Part3' | translate}}.
          </p>
        </div>
        <div class="container-row">
          <div class="container-subtitle fade-in fade-in-delay-8">
            <i class="figure-circle"></i>
            <h3 class="subtitle-main">
              {{'VirtualProcurement.Subtitle4' | translate}}
            </h3>
          </div>
          <p class="text-info fade-in fade-in-delay-9">
            {{'VirtualProcurement.Text4Part1' | translate}} <strong style="font-weight:600">{{'VirtualProcurement.Text4Part2' | translate}}.</strong>
          </p>
        </div>
      </div>

      <div class="column-img fade-in-right-js only-mobile">
        <figure class="figure-img">
          <img src="../../../../assets/img/to_do_fruzty/procurement_virtual.png" style="width: 80%" alt="flag"/>
        </figure>
      </div>

    </div>
  </div>

</app-user-dashboard>

<app-footer-home></app-footer-home>
